/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
export enum TockProductType {
  EVENTS = 'EVENTS',
  CLASSIC = 'CLASSIC',
}
export const EVENTS_PRODUCT_TYPE = TockProductType.EVENTS as TockProductType.EVENTS;
export const CLASSIC_PRODUCT_TYPE = TockProductType.CLASSIC as TockProductType.CLASSIC;

export enum TockClassicProductLevel {
  INTRO = 'INTRO',
  PLUS = 'PLUS',
  PRO = 'PRO',
}

export enum TockEventsProductLevel {
  ESSENTIAL = 'ESSENTIAL',
  PREMIUM = 'PREMIUM',
}

// This is a funny way to get both a type and value enum that is the union
// of the two enums above.
export const TockProductLevel = Object.assign({}, TockClassicProductLevel, TockEventsProductLevel);
export type TockProductLevel = TockEventsProductLevel | TockClassicProductLevel;
